import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';

import { defaultApi } from '../../apis';
import IbIcon from '../common/IbIcon';
import { alertsSelectorAdd } from '../../recoil';
import { getTranslateFunc } from '../../utils/stringUtil';
import { downloadNamedFile } from '../../utils/fileUtil';
import ProgressPanel from '../ProgressPanel';

interface IFolderExportProps {
  folderId: string;
}

const FolderExport: React.FC<IFolderExportProps> = ({ folderId, children }) => {
  const translate = getTranslateFunc('Folder: Export:');

  const addAlert = useSetRecoilState(alertsSelectorAdd);

  const [progressPanelVisible, setProgressPanelVisible] = useState(false);

  const onExportClick = async () => {
    setProgressPanelVisible(true);
    try {
      const response = await defaultApi.exportFolderArchive(folderId, { responseType: 'blob' });
      downloadNamedFile(response);
    } catch (e) {
      addAlert({
        content: translate('Error'),
        type: 'error',
        icon: <IbIcon iconName="attention" />,
      });
      // eslint-disable-next-line no-console
      console.error(e);
    }
    setProgressPanelVisible(false);
  };

  return (
    <>
      <span role="button" tabIndex={0} onClick={onExportClick}>
        {children}
      </span>
      <ProgressPanel.FolderExport visible={progressPanelVisible} />
    </>
  );
};

export default FolderExport;
